import { render, staticRenderFns } from "./AdminUserKey.vue?vue&type=template&id=3b4f37f8&"
import script from "./AdminUserKey.vue?vue&type=script&lang=js&"
export * from "./AdminUserKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4f37f8')) {
      api.createRecord('3b4f37f8', component.options)
    } else {
      api.reload('3b4f37f8', component.options)
    }
    module.hot.accept("./AdminUserKey.vue?vue&type=template&id=3b4f37f8&", function () {
      api.rerender('3b4f37f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AdminUserKey.vue"
export default component.exports